<template>
	<div class="modal-body">
		<div class="row">
			<div class="col-sm-8">
				<span>Empresa</span>
				<input
					class="form-control"
					type="text"
					v-model="data.nome"
					disabled
				/>
			</div>
			<div class="col-sm-4">
				<span>Atividade Sel.</span>
				<input
					class="form-control"
					type="text"
					v-model="data.atividade_sel"
					disabled
				/>
			</div>

			<div class="col-sm-7">
				<span>Email</span>
				<input
					class="form-control"
					type="text"
					v-model="data.email"
					disabled
				/>
			</div>
			<div class="col-sm-5">
				<span>Telefone</span>
				<input
					class="form-control"
					type="text"
					v-model="data.telefone"
					disabled
				/>
			</div>

			<div class="col-sm-4">
				<span>CNPJ</span>
				<input
					class="form-control"
					type="text"
					v-model="data.cnpj"
					disabled
				/>
			</div>
			<div class="col-sm-8">
				<span>Nat. Juridica</span>
				<input
					class="form-control"
					type="text"
					v-model="data.natureza_juridica"
					disabled
				/>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'userMdSstInformation',
		props: ['dataIn'],
		computed: {
			data() {
				return this.dataIn.sst_id;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/users/modal/sstInfo.vue